<template>
  <div class="recordSectionSettings">
    <div class="switchLine">
      <div class="labelSwitch">{{ $t('settings.panel.sectionHelperSound') }}</div>
      <div>
        <w-switch size="small" @input="setSectionSound"
                  :value="isSectionSound"
        />
      </div>
    </div>
    <div class="switchLine">
      <div class="labelSwitch">{{ $t('settings.panel.sectionHelperNotification') }}</div>
      <div>
        <w-switch size="small" @input="setSectionNotification"
                  :value="isSectionNotification"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import store from '@/store';
import WSwitch from '@/components/wrapper/w-switch.vue';
import {setActionEvent} from '@/utils/tracker';
import {ActionEvent} from '@/enum/TrackerEnum';
import {SettingUsersKey} from '@/store/settingUsers/settingUserKey';
import {SET_SETTINGUSER, SettingUserParams} from '@/store/settingUsers/settingUserAction';
import {showNotification} from '@/utils/notification';

@Component({
  components: {WSwitch},
})
export default class RecordSectionSettings extends Vue {

  get isSectionSound(): boolean {
    return store.getters.isTimeSectionSoundActivated;
  }

  get isSectionNotification(): boolean {
    return store.getters.isTimeSectionNotificationActivated;
  }

  public setSectionSound(value: boolean) {
    const params = new SettingUserParams(SettingUsersKey.TIME_SECTION_SOUND, value);
    store.dispatch(SET_SETTINGUSER, params).then(() => {
      setActionEvent(ActionEvent.setting_time_section_sound,
          {value_section_sound: value});
    });
  }

  public setSectionNotification(value: boolean) {
    const params = new SettingUserParams(SettingUsersKey.TIME_SECTION_NOTIFICATION, value);
    if (value) {
      showNotification(
          this.$t('sectionHelper.nativeNotification.title').toString(),
          this.$t('sectionHelper.nativeNotification.description').toString()
      );
    }
    store.dispatch(SET_SETTINGUSER, params).then(() => {
      setActionEvent(ActionEvent.setting_time_section_notification,
          {value_section_notification: value});
    });
  }
}
</script>

<style scoped lang="scss">
.recordSectionSettings {
  color: #1B3954;

  .switchLine {
    display: flex;
    margin-top: 24px;
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 8px;

    .labelSwitch {
      text-align: left;
      color: var(--black);
      font-size: 14px;
      font-weight: 600;
      margin-right: 16px;
      flex: 1;
    }
  }
}
</style>
